import {Box, Colors} from "@bounce/shared/ui";
import {InfoTooltip} from "./InfoTooltip";
import {TooltipRow} from "./TooltipRow";
import {TooltipSummary} from "./TooltipSummary";

export type AccountCountSummaryType = "account" | "campaign";

const COLLECTIBLE_CRITERIA = [
  "is open",
  "isn't in a communication freeze",
  "has no cease-and-desist on file",
  "isn't in bankruptcy",
  "hasn't been recalled by the creditor",
  "isn't past its statute of limitations",
  "has no active or late payment plan",
];

const Bullet = () => (
  <Box sx={{flexShrink: 0, width: 5, height: 5, mt: "7px", borderRadius: "50%", backgroundColor: Colors.blue._700}} />
);

const AccountCountContent = ({summaryType}: {summaryType: AccountCountSummaryType}) => (
  <Box sx={{py: 0.25}}>
    <TooltipSummary>
      {summaryType === "account" ? (
        <>
          An estimate of the segment's <b>collectible</b> accounts - those eligible for outreach. An account is counted
          only when it:
        </>
      ) : (
        <>
          An estimate of the <b>collectible</b> accounts across every audience in this campaign. Each account belongs to
          exactly one audience, so the audiences never overlap and their totals add up. An account is counted only when
          it:
        </>
      )}
    </TooltipSummary>
    <Box sx={{mt: 1, display: "flex", flexDirection: "column", gap: 0.5}}>
      {COLLECTIBLE_CRITERIA.map((c) => (
        <TooltipRow key={c} marker={<Bullet />}>
          {c}
        </TooltipRow>
      ))}
    </Box>
  </Box>
);

export const AccountCountInfoTooltip = ({summaryType = "account"}: {summaryType?: AccountCountSummaryType}) => (
  <InfoTooltip content={<AccountCountContent summaryType={summaryType} />} size={13} color={Colors.grey._600} />
);
